/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button } from "@mui/material";

import React, { useEffect, useState } from "react";



import { t } from "i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import SearchOptionMenu from "./SearchOptionMenu";
import Progress from "../../../../components/Loader/Progress ";
import AdvancedSearch from "../../../Vehicles/Components/searchOptionComponents/MultiFieldSearch ";
import { searchClient, searchDestination, searchPortLoading, searchShippingLine } from "../../../../actions/formAction";
import DynamicSearchMenu from "../../../Booking/Components/searchOptionComponents/DynamicSearchMenu";
import MixSearch from "../../../Booking/Components/searchOptionComponents/MixSearch";
import BookingStatusMenu from "../../../Booking/Components/searchOptionComponents/BookingStatusMenu";
import QueryMultiSelectMenu from "../../../../components/filters/QueryMultiSelectMenu";

const DropdownMenu = ({ onFetchData }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const formReducer = useSelector((state) => state.verificationShipment);

  const [adavancedSearchPrems, setAdavancedSearchPrems] = useState(
    formReducer?.data?.advancedSearches || []
  );



  useEffect(() => {
    if (formReducer.loading === "succeeded") {
      setAdavancedSearchPrems(formReducer?.data?.advancedSearches || []);
    }
  }, [formReducer.loading]);

  const handelResetFilter = () => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.delete("ShippingLine");
    searchParams.delete("PortLoading");
    searchParams.delete("Destination");
    searchParams.delete("SearchOption");
    searchParams.delete("Status");
    searchParams.delete("AdvancedSearch");
    searchParams.delete("Destination");
    searchParams.delete("MixSearch");
    searchParams.delete("Clients");
    searchParams.delete("BookingId");


    navigate({ search: searchParams.toString() });
  };

  return (
    <Box sx={{
      p: { xs: 1, md: 2 },
      background: '#fff',
      borderRadius: 3,
      boxShadow: '0 2px 12px 0 rgba(11, 60, 93, 0.08)',
      mb: 2,
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      width: '100%',
    }}>
      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'flex-start',
        width: '100%',
      }}>

         <BookingStatusMenu Selector={useSelector((state) => state.verificationShipment)} />


          <QueryMultiSelectMenu
              title="Shipment Mode"
              queryParam="ShipmentMode"
              allLabel="All Modes"
              options={[
                  { value: 'FCL', label: 'FCL' },
                  { value: 'LCL', label: 'LCL' },
                  { value: 'SPL', label: 'SPL' },
              ]}
          />

        <DynamicSearchMenu label="Clients" paramSelectName1='name' paramSelectName2='company' queryParam="Clients" loadingKey="isLoadingClientData" dataKey="client" fetchAction={searchClient} />

        <DynamicSearchMenu label="Destinations" queryParam="Destination" loadingKey="isLoadingDestinationData" dataKey="destination" fetchAction={searchDestination} />

        <DynamicSearchMenu label="Port Loadings" queryParam="PortLoading" loadingKey="isLoadingPortData" dataKey="portLoading" fetchAction={searchPortLoading} />
        <DynamicSearchMenu label="Shipping Lines" queryParam="ShippingLine" loadingKey="isLoadingShippingLineData" dataKey="shippingLine" fetchAction={searchShippingLine} />

        <SearchOptionMenu />
        {formReducer.loading === "pending" || formReducer.loading === "idle" ? <Progress /> :
          <AdvancedSearch
            filter={adavancedSearchPrems}
          />

        }



        <Button
          color="colorD"
          variant="outlined"
          sx={{ minWidth: 120, borderRadius: 2, fontWeight: 700, borderColor: '#D9B310', color: '#0B3C5D', '&:hover': { background: '#D9B31022', borderColor: '#D9B310', color: '#0B3C5D' } }}
          onClick={handelResetFilter}
        >
          {t("ResetFilter")}
        </Button>
        <Button
          variant="b1"
          sx={{ minWidth: 120, borderRadius: 2, fontWeight: 700 }}
          onClick={onFetchData}
        >
          {t('FetchData')}
        </Button>
      </Box>

      <MixSearch/>

      <Box sx={{ width: '100%' }}>
      </Box>
    </Box>
  );
};

export default DropdownMenu;
